import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PaymentModalContextType {
  isPaymentModalOpen: boolean;
  setPaymentModalOpen: (open: boolean) => void;
}

const PaymentModalContext = createContext<PaymentModalContextType | undefined>(undefined);

export function PaymentModalProvider({ children }: { children: ReactNode }) {
  const [isPaymentModalOpen, setPaymentModalOpen] = useState(false);

  return (
    <PaymentModalContext.Provider value={{ isPaymentModalOpen, setPaymentModalOpen }}>
      {children}
    </PaymentModalContext.Provider>
  );
}

export function usePaymentModal() {
  const context = useContext(PaymentModalContext);
  if (context === undefined) {
    throw new Error('usePaymentModal must be used within a PaymentModalProvider');
  }
  return context;
}
